import React from "react";
import styled from "styled-components";

const TopBanner = ({ content }) => {
  return (
    <BannerWrapper>
      <Overlay>
        <Content>
          <h1>{content}</h1>
        </Content>
      </Overlay>
    </BannerWrapper>
  );
};

export default TopBanner;

const BannerWrapper = styled.div`
  width: 100%;
  height: 60vh;
  background-image: url("https://plus.unsplash.com/premium_photo-1683120730432-b5ea74bd9047?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover;
  background-position: center;
  position: relative;
  margin-top: 131px;

  @media (max-width: 768px) {
    height: 60vh;
    margin-top: 75px;
  }
`;

const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.5); /* dark overlay for text contrast */
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  text-align: center;
  color: #fff;
  max-width: 700px;
  padding: 0 1rem;

  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
    font-weight: 700;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.1rem;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
`;
